import ru from "./locales/ru.kcv.txt";
import en from "./locales/en.kcv.txt";
import tongues from "tongues";

export const locales = tongues({ en, ru });
